import { jsxs, jsx } from "react/jsx-runtime";
const CartWidget = ({ data }) => {
  const { item, qty, total, isSubscription } = data;
  return /* @__PURE__ */ jsxs(
    "div",
    {
      style: {
        width: "100%",
        maxWidth: 400,
        background: "var(--voice-widget-card-bg, #FFFFFF)",
        border: "1px solid var(--voice-widget-border, #E5E7EB)",
        borderRadius: 16,
        padding: "20px 20px 16px",
        boxSizing: "border-box",
        boxShadow: "0 2px 12px rgba(0,0,0,0.07)"
      },
      children: [
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              fontSize: 12,
              fontWeight: 700,
              letterSpacing: 0.5,
              textTransform: "uppercase",
              color: "var(--voice-widget-accent, #7DD3C0)",
              marginBottom: 12
            },
            children: "Added to cart"
          }
        ),
        /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: 12, alignItems: "flex-start" }, children: [
          item.imageUrl && /* @__PURE__ */ jsx(
            "img",
            {
              src: item.imageUrl,
              alt: item.title,
              style: {
                width: 64,
                height: 64,
                objectFit: "contain",
                borderRadius: 8,
                background: "var(--voice-widget-img-bg, #F9FAFB)",
                flexShrink: 0
              }
            }
          ),
          /* @__PURE__ */ jsxs("div", { style: { flex: 1, minWidth: 0 }, children: [
            /* @__PURE__ */ jsx(
              "div",
              {
                style: {
                  fontSize: 14,
                  fontWeight: 600,
                  color: "var(--voice-widget-fg, #111827)",
                  lineHeight: 1.35,
                  marginBottom: 4
                },
                children: item.title
              }
            ),
            /* @__PURE__ */ jsxs("div", { style: { fontSize: 13, color: "var(--voice-widget-muted, #6B7280)" }, children: [
              "Qty: ",
              qty,
              isSubscription && " · Subscribe & Save"
            ] })
          ] })
        ] }),
        /* @__PURE__ */ jsx(
          "div",
          {
            style: {
              borderTop: "1px solid var(--voice-widget-border, #E5E7EB)",
              margin: "14px 0 12px"
            }
          }
        ),
        /* @__PURE__ */ jsxs(
          "div",
          {
            style: {
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              marginBottom: 14
            },
            children: [
              /* @__PURE__ */ jsx("span", { style: { fontSize: 13, color: "var(--voice-widget-muted, #6B7280)" }, children: "Total" }),
              /* @__PURE__ */ jsx("span", { style: { fontSize: 18, fontWeight: 700, color: "var(--voice-widget-fg, #111827)" }, children: total })
            ]
          }
        ),
        /* @__PURE__ */ jsxs("div", { style: { display: "flex", gap: 8 }, children: [
          /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              style: {
                flex: 1,
                padding: "10px 12px",
                borderRadius: 999,
                border: "none",
                background: "var(--voice-widget-accent, #7DD3C0)",
                color: "var(--voice-widget-accent-fg, #FFFFFF)",
                fontSize: 13,
                fontWeight: 700,
                cursor: "pointer"
              },
              children: "Checkout"
            }
          ),
          /* @__PURE__ */ jsx(
            "button",
            {
              type: "button",
              style: {
                flex: 1,
                padding: "10px 12px",
                borderRadius: 999,
                border: "1.5px solid var(--voice-widget-border, #E5E7EB)",
                background: "transparent",
                color: "var(--voice-widget-fg, #111827)",
                fontSize: 13,
                fontWeight: 600,
                cursor: "pointer"
              },
              children: "Keep talking"
            }
          )
        ] })
      ]
    }
  );
};
export {
  CartWidget
};
//# sourceMappingURL=CartWidget.js.map
